import CONTRATO_DIRECTORIOS from '@/graphql/querys/administracion/contratos/contrato/directorios/contratoDirectorios.gql';
import AGREGAR_CONTRATO_DIRECTORIO from '@/graphql/mutations/administracion/contratos/contrato/directorios/agregarContratoDirectorio.gql';
import ACTUALIZAR_CONTRATO_DIRECTORIO from '@/graphql/mutations/administracion/contratos/contrato/directorios/actualizarContratoDirectorio.gql';
import REMOVER_CONTRATO_DIRECTORIO from '@/graphql/mutations/administracion/contratos/contrato/directorios/removerContratoDirectorio.gql';

export default {
  methods: {
    async mixAgregarDirectorio() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { idContrato } = this;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_DIRECTORIO,
          variables: { directorio: this.directorio },
          update: (store, { data: { agregarContratoDirectorio } }) => {
            const data = store
              .readQuery({
                query: CONTRATO_DIRECTORIOS,
                variables: {
                  idContrato,
                },
              });
            data.contratoDirectorios.push(agregarContratoDirectorio);
            store.writeQuery({
              query: CONTRATO_DIRECTORIOS,
              variables: {
                idContrato,
              },
              data,
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEditarDirectorio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { idContrato } = this.directorioEditar;
      const { id } = this.directorioEditar;
      const { directorio } = this;
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CONTRATO_DIRECTORIO,
        variables: {
          id,
          directorio,
        },
        update: (store, { data: { actualizarContratoDirectorio } }) => {
          const data = store
            .readQuery({
              query: CONTRATO_DIRECTORIOS,
              variables: {
                idContrato,
              },
            });
          const { contratoDirectorios } = data;
          const index = contratoDirectorios
            .findIndex((m) => m.id === actualizarContratoDirectorio.id);
          if (index !== -1) {
            contratoDirectorios.splice(index, 1, actualizarContratoDirectorio);
          }
          store.writeQuery({
            query: CONTRATO_DIRECTORIOS,
            variables: {
              idContrato,
            },
            data,
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarDirectorio() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idDirectorio = this.directorioEliminar.id;
      const { idContrato } = this.directorioEliminar;
      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_DIRECTORIO,
        variables: {
          id: idDirectorio,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_DIRECTORIOS,
            variables: {
              idContrato,
            },
          };
          const data = store.readQuery(query);
          const index = data.contratoDirectorios
            .findIndex(({ id }) => id === idDirectorio);
          if (index !== -1) {
            data.contratoDirectorios.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
